function isAssigned(object) {
    return ((object?.nbAtoms && object.nbAtoms > 0) ||
        (object?.diaIDs && object.diaIDs.length > 0));
}
export function isRangeAssigned(range) {
    if (isAssigned(range)) {
        return true;
    }
    return range?.signals.some((signal) => isAssigned(signal));
}
